<template>
  <section class="package-rate-page">
    <div class="page-header">
      <span class="header-title">Package Rate</span>
    </div>

    <div class="club-row">
      <label class="club-label">Golf Club</label>
      <select v-model="selectedClub" class="club-select">
        <option v-for="club in clubs" :key="club" :value="club">{{ club }}</option>
      </select>
    </div>

    <div class="content-shell">
      <div class="tab-bar">
        <button type="button" :class="['tab-btn', { active: activeTab === 'list' }]" @click="activeTab = 'list'">
          PACKAGE LIST
        </button>
        <button type="button" :class="['tab-btn', { active: activeTab === 'item' }]" @click="activeTab = 'item'">
          PACKAGE ITEM
        </button>
      </div>

      <div v-if="activeTab === 'list'" class="main-panels list-view">
        <aside class="list-panel">
          <div class="list-header">
            <div class="header-cell package-col">Package</div>
            <div class="header-cell holes-col">Holes</div>
            <div class="header-cell status-col">Status</div>
          </div>

          <div
            v-for="pkg in packages"
            :key="pkg.code"
            :class="['list-row', { selected: selectedPackageCode === pkg.code }]"
            @click="selectedPackageRate(pkg)"
          >
            <div class="package-text">
              <span class="package-mark" v-if="selectedPackageCode === pkg.code">◆</span>
              {{ pkg.code }} - {{ pkg.name }}
            </div>
            <div class="holes-text">{{ pkg.holes }}</div>
            <div class="status-text">{{ pkg.status }}</div>
          </div>
        </aside>

        <main class="detail-panel">
          <div class="detail-topbar">
            <div class="field-row">
              <label>Package Code*</label>
              <input :value="selectedPackage.code" readonly>
            </div>
            <div class="field-row field-right">
              <label>Status</label>
              <input :value="selectedPackage.status" readonly>
            </div>
          </div>

          <div class="detail-topbar second-row">
            <div class="field-row big">
              <label>Package Name*</label>
              <input :value="selectedPackage.name" readonly>
            </div>
          </div>

          <div class="detail-middle">
            <div class="left-form">
              <div class="form-block">
                <div class="inline-row small-gap">
                  <div class="radio-group">
                    <span class="label-inline">Package For:</span>
                    <label><input type="radio" checked> Regular</label>
                  </div>
                </div>

                <div class="inline-row small-gap compact-row">
                  <div class="label-col">Player Type</div>
                  <div class="checkboxes">
                    <label><input type="checkbox"> Guest</label>
                    <label><input type="checkbox" checked> Member</label>
                    <label><input type="checkbox"> All Membership Class</label>
                  </div>
                </div>

                <div class="inline-row small-gap compact-row">
                  <div class="label-col">Time Zone</div>
                  <div class="checkboxes">
                    <label><input type="checkbox" checked> Morning</label>
                    <label><input type="checkbox" checked> Afternoon</label>
                    <label><input type="checkbox"> Night</label>
                  </div>
                </div>

                <div class="inline-row small-gap compact-row">
                  <div class="label-col">Valid For Group</div>
                  <div class="radio-inline">
                    <label><input type="radio" name="validGroup" checked> Yes</label>
                    <label><input type="radio" name="validGroup"> No</label>
                  </div>
                </div>

                <div class="inline-row small-gap compact-row">
                  <div class="label-col">Reservation Type</div>
                  <div class="checkboxes">
                    <label><input type="checkbox"> Half Day Morning</label>
                    <label><input type="checkbox"> Half Day Afternoon</label>
                    <label><input type="checkbox"> Half Day Night</label>
                    <label><input type="checkbox"> Full Day</label>
                  </div>
                </div>

                <div class="inline-row small-gap compact-row">
                  <div class="label-col">Golf Discount Card</div>
                  <div class="radio-inline">
                    <label><input type="radio" name="discountCard"> No</label>
                    <label><input type="radio" name="discountCard" checked> Yes</label>
                  </div>
                </div>
              </div>

              <div class="form-block note-block">
                <div class="inline-row small-gap">
                  <div class="label-col">Is Complimentary</div>
                  <div class="radio-inline">
                    <label><input type="radio" name="complimentary"> No</label>
                    <label><input type="radio" name="complimentary" checked> Yes</label>
                  </div>
                </div>

                <div class="inline-row small-gap compact-row note-row">
                  <div class="label-col">Note</div>
                  <input type="text" value="For member only" readonly>
                </div>
              </div>

              <div class="meta-row">
                <div class="meta-box">
                  <label>Updated By</label>
                  <div class="meta-value">5-Jan-2021 14:32</div>
                  <div class="meta-user">Admin</div>
                </div>
                <div class="meta-box">
                  <label>Created By</label>
                  <div class="meta-value">5-Jan-2021 14:32</div>
                  <div class="meta-user">Admin</div>
                </div>
              </div>

              <div class="button-row">
                <button class="btn btn-light">Add New</button>
                <button class="btn btn-light">Edit</button>
                <button class="btn btn-light">Delete</button>
                <button class="btn btn-light">Re-Draft</button>
                <button class="btn btn-light">Activate</button>
                <button class="btn btn-light">Inactive</button>
                <button class="btn btn-primary save-btn">Save</button>
                <button class="btn btn-light">Cancel</button>
              </div>
            </div>

            <div class="right-panel">
              <div class="membership-box">
                <div class="membership-header">Membership Class</div>
                <div class="membership-list">
                  <div class="membership-item selected">IND - ANGGOTA BIASA</div>
                  <div class="membership-item">IND - ANGGOTA BIASA 60-70</div>
                  <div class="membership-item">IND - ANGGOTA BIASA &gt; 70</div>
                </div>
                <div class="membership-footer">
                  <label class="check-inline"><input type="checkbox"> Include Supplementary</label>
                  <button class="btn btn-light small-btn">Add Class</button>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>

      <div v-else class="package-item-view">
        <div class="package-item-shell">
          <div class="package-item-header row-1">
            <span>Package Rate</span>
            <span class="header-code">{{ selectedPackage.code }}</span>
            <span>{{ selectedPackage.name }}</span>
          </div>

          <div class="package-item-header row-2">
            <span class="header-label">Package Period</span>
          </div>

          <div class="item-layout">
            <aside class="period-panel">
              <div class="period-box">
                <div class="box">
                    <div class="box-header" style="height: 50px; margin-top: 10px; text-align:left">
                        <div class="box-tools">              
                        <button v-on:click="" class="btn btn-primary">Add</button>
                        <button v-on:click="" class="btn btn-warning">Edit</button>
                        <button v-on:click="" class="btn btn-warning">Delete</button>
                        </div>
                    </div>        
                    <div class="box-body no-padding table-responsive">
                    <table class="price-table">
                        <thead>
                        <tr>
                            <th style="width: 45px;text-align:center;">#</th>
                            <th>Valid From</th>
                            <th>Valid To</th>
                        </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(row, i) in selectedPackageItems" v-bind:key="i" :class="{ 'is-selected': selectedRowPackageRateId === row.id }">
                                <td style="width:85px;text-align:left;">
                                    <a href="#" ref="displayRow" v-on:click="displayRowPackageRateDetail(row)" style="padding-right:5px">
                                        <span class="icon ion-search" data-toggle="tooltip" data-placement="right" title="Display"></span>
                                    </a>
                                </td>
                                <td>{{ row.validFrom }}</td>
                                <td>{{ row.validTo }}</td>
                                <td hidden>{{ row.id }}</td>
                            </tr>
                        </tbody>
                    </table>
                    </div>
                </div>
              </div>
              <div class="period-meta">
                <div class="meta-row-box">
                  <div class="meta-label">Updated By</div>
                  <div class="meta-value">5-Jan-2021 21:07:18</div>
                </div>
                <div class="meta-row-box">
                  <div class="meta-label">Number of Items</div>
                  <div class="meta-value">{{ selectedPackageItems.length }}</div>
                </div>
                <div class="meta-row-box">
                  <div class="meta-label">Weekdays Rate</div>
                  <div class="meta-value">{{ formatMoney(subtotal.weekday) }}</div>
                </div>
                <div class="meta-row-box">
                  <div class="meta-label">Saturday Rate</div>
                  <div class="meta-value">{{ formatMoney(subtotal.saturday) }}</div>
                </div>
                <div class="meta-row-box">
                  <div class="meta-label">Sunday Rate</div>
                  <div class="meta-value">{{ formatMoney(subtotal.sunday) }}</div>
                </div>
                <div class="meta-row-box">
                  <div class="meta-label">Holiday Rate</div>
                  <div class="meta-value">{{ formatMoney(subtotal.holiday) }}</div>
                </div>
              </div>
            </aside>

            <main class="price-panel">
              <div class="price-panel-header">Package Item</div>
              <table class="price-table">
                <thead>
                  <tr>
                    <th>Service</th>
                    <th>Weekday Price</th>
                    <th>Saturday Price</th>
                    <th>Sunday Price</th>
                    <th>Holiday Price</th>
                    <th>Service Charge</th>
                    <th>Tax 1</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in selectedPackageItemDetails" :key="item.name" 
                    :class="{ 'is-selected': selectedRowDetailId === item.id }" @click="selectedPackageItemsRate(item)">
                    <td>{{ item.name }}</td>
                    <td>{{ formatMoney(item.weekday) }}</td>
                    <td>{{ formatMoney(item.saturday) }}</td>
                    <td>{{ formatMoney(item.sunday) }}</td>
                    <td>{{ formatMoney(item.holiday) }}</td>
                    <td>{{ item.serviceCharge }}</td>
                    <td>{{ item.tax }}</td>
                  </tr>
                </tbody>
              </table>

              <div class="summary-grid">
                <div class="summary-row head">
                  <span>Breakdown Rate Amount</span>
                  <span>Weekday</span>
                  <span>Saturday</span>
                  <span>Sunday</span>
                  <span>Holiday</span>
                </div>
                <div class="summary-row">
                  <span>Price</span>
                  <span>{{ formatMoney(breakdown.weekday.price) }}</span>
                  <span>{{ formatMoney(breakdown.saturday.price) }}</span>
                  <span>{{ formatMoney(breakdown.sunday.price) }}</span>
                  <span>{{ formatMoney(breakdown.holiday.price) }}</span>
                </div>
                <div class="summary-row">
                  <span>Service Charge</span>
                  <span>{{ formatMoney(breakdown.weekday.serviceCharge) }}</span>
                  <span>{{ formatMoney(breakdown.saturday.serviceCharge) }}</span>
                  <span>{{ formatMoney(breakdown.sunday.serviceCharge) }}</span>
                  <span>{{ formatMoney(breakdown.holiday.serviceCharge) }}</span>
                </div>
                <div class="summary-row">
                  <span>Tax</span>
                  <span>{{ formatMoney(breakdown.weekday.tax) }}</span>
                  <span>{{ formatMoney(breakdown.saturday.tax) }}</span>
                  <span>{{ formatMoney(breakdown.sunday.tax) }}</span>
                  <span>{{ formatMoney(breakdown.holiday.tax) }}</span>
                </div>
                <div class="summary-row total">
                  <span>Service Net Amount</span>
                  <span>{{ formatMoney(breakdown.weekday.netAmount) }}</span>
                  <span>{{ formatMoney(breakdown.saturday.netAmount) }}</span>
                  <span>{{ formatMoney(breakdown.sunday.netAmount) }}</span>
                  <span>{{ formatMoney(breakdown.holiday.netAmount) }}</span>
                </div>
              </div>
            </main>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'PackageRate',
  data() {
    return {
      activeTab: 'list',
      selectedClub: 'Realta Golf Club',
      selectedPackageCode: 'MWDM18',
      clubs: ['Realta Golf Club', 'Perfect Golf Course', 'Emerald Golf Club'],
      startSequence: 0,
      packages: [
        { id: 1, code: 'MWDM18', name: 'Member Weekday 18 Holes', holes: 18, status: 'Draft' },
        { id: 2, code: 'MWDM09', name: 'Member Weekday 9 Holes', holes: 9, status: 'Active' },
        { id: 3, code: 'MWEM18', name: 'Member Weekend 18 Holes', holes: 18, status: 'Draft' }
      ],
      packageItems: [
        {
          packageId: 1,
          id: 1,
          validFrom: '2026-08-01',
          validTo: '2026-10-31',
          status: 'Active',
          details: [
            { id: 1, name: 'CART FEE MEMBER (18 H)', weekday: 200000, saturday: 200000, sunday: 200000, holiday: 200000, serviceCharge: 'None', tax: 'Include' },
            { id: 2, name: 'CADDY FEE (18 H)', weekday: 100000, saturday: 100000, sunday: 100000, holiday: 100000, serviceCharge: 'None', tax: 'Include' },
            { id: 3, name: 'INSURANCE FEE', weekday: 15000, saturday: 15000, sunday: 15000, holiday: 15000, serviceCharge: 'None', tax: 'Include' }
          ]
        },
        {
          packageId: 1,
          id: 2,
          validFrom: '2026-10-01',
          validTo: '2026-12-31',
          status: 'Active',
          details: [
            { id: 1, name: 'CART FEE MEMBER (18 H)', weekday: 200000, saturday: 200000, sunday: 200000, holiday: 200000, serviceCharge: 'None', tax: 'Exclude' },
            { id: 2, name: 'CADDY FEE (18 H)', weekday: 100000, saturday: 100000, sunday: 100000, holiday: 100000, serviceCharge: 'None', tax: 'Exclude' },
            { id: 3, name: 'INSURANCE FEE', weekday: 15000, saturday: 15000, sunday: 15000, holiday: 15000, serviceCharge: 'None', tax: 'Exclude' }
          ]
        },
        {
          packageId: 2,
          id: 3,
          validFrom: '2026-08-01',
          validTo: '2026-12-31',
          status: 'Active',
          details: [
            { id: 1, name: 'CART FEE MEMBER (18 H)', weekday: 200000, saturday: 200000, sunday: 200000, holiday: 200000, serviceCharge: 'None', tax: 'None' },
            { id: 2, name: 'CADDY FEE (18 H)', weekday: 100000, saturday: 100000, sunday: 100000, holiday: 100000, serviceCharge: 'None', tax: 'None' },
            { id: 3, name: 'INSURANCE FEE', weekday: 15000, saturday: 15000, sunday: 15000, holiday: 15000, serviceCharge: 'None', tax: 'None' }
          ]
        }
      ],
      selectedPackage: [],
      selectedPackageItems: [],
      selectedPackageItemDetails: [],
      subtotal: {
        weekday: 0,
        saturday: 0,
        sunday: 0,
        holiday: 0
      },
      breakdown: {
        weekday: {
          price: 0,
          serviceCharge: 0,
          tax: 0,
          netAmount: 0
        },
        saturday: {
          price: 0,
          serviceCharge: 0,
          tax: 0,
          netAmount: 0
        },
        sunday: {
          price: 0,
          serviceCharge: 0,
          tax: 0,
          netAmount: 0
        },
        holiday: {
          price: 0,
          serviceCharge: 0,
          tax: 0,
          netAmount: 0
        }
      },
      selectedRowPackageRateId: 0,
      selectedRowDetailId: 0
    }
  },
  computed: {
    selectedPackage() {
      return this.packages.find(pkg => pkg.code === this.selectedPackageCode) || this.packages[0]
    }
  },
  methods: {
    formatMoney(value) {
      return Number(value).toLocaleString('id-ID', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    },
    selectedPackageRate(row) {
      this.selectedPackage = this.packages.find(pkg => pkg.code === row.id) || this.packages[0]
      this.selectedPackageCode = row.code
      this.selectedPackageItems = this.packageItems.filter(items => items.packageId === row.id)
      this.selectedPackageItemDetails = this.selectedPackageItems.length > 0 ? this.selectedPackageItems[0].details : []
      console.log(this.selectedPackageItems)
      this.subtotal = this.selectedPackageItemDetails.reduce((acc, item) => {
        acc.weekday += item.weekday
        acc.saturday += item.saturday
        acc.sunday += item.sunday
        acc.holiday += item.holiday
        return acc
      }, { weekday: 0, saturday: 0, sunday: 0, holiday: 0 })

      console.log(this.subtotal)
    },
    displayRowPackageRateDetail(row) {
      let item = this.packageItems.find(items => items.id === row.id)
      console.log(item)
      this.selectedRowPackageRateId = item.id
      this.selectedPackageItemDetails = item.details
    },
    selectedPackageItemsRate(row) {
      let detail = this.selectedPackageItemDetails.find(items => items.id === row.id)
      console.log(detail)
      this.selectedRowDetailId = row.id

      this.breakdown.weekday.price = detail.weekday
      this.breakdown.weekday.serviceCharge = (detail.weekday * (detail.serviceCharge === 'None' ? 0 : 0.03))
      this.breakdown.weekday.tax = (detail.weekday * (detail.tax === 'None' ? 0 : (10 / 100)))
      this.breakdown.weekday.netAmount = detail.weekday - (this.breakdown.weekday.serviceCharge + this.breakdown.weekday.tax)

      this.breakdown.saturday.price = detail.saturday
      this.breakdown.saturday.serviceCharge = (detail.saturday * (detail.serviceCharge === 'None' ? 0 : 0.03))
      this.breakdown.saturday.tax = (detail.saturday * (detail.tax === 'None' ? 0 : (10 / 100)))
      this.breakdown.saturday.netAmount = detail.saturday - (this.breakdown.saturday.serviceCharge + this.breakdown.saturday.tax)

      this.breakdown.sunday.price = detail.saturday
      this.breakdown.sunday.serviceCharge = (detail.saturday * (detail.serviceCharge === 'None' ? 0 : 0.03))
      this.breakdown.sunday.tax = (detail.saturday * (detail.tax === 'None' ? 0 : (10 / 100)))
      this.breakdown.sunday.netAmount = detail.saturday - (this.breakdown.sunday.serviceCharge + this.breakdown.sunday.tax)

      this.breakdown.holiday.price = detail.saturday
      this.breakdown.holiday.serviceCharge = (detail.saturday * (detail.serviceCharge === 'None' ? 0 : 0.03))
      this.breakdown.holiday.tax = (detail.saturday * (detail.tax === 'None' ? 0 : (10 / 100)))
      this.breakdown.holiday.netAmount = detail.saturday - (this.breakdown.holiday.serviceCharge + this.breakdown.holiday.tax)
    }
  }
}
</script>

<style scoped>
.package-rate-page {
  background: #f1f5fb;
  min-height: 100%;
  padding: 10px 12px 20px;
  color: #2c4059;
  font-family: Arial, Helvetica, sans-serif;
}

.page-header {
  background: rgba(255,255,255,0.5);
  border: 1px solid #bfd0ea;
  border-bottom: none;
  padding: 12px 14px;
  font-weight: 700;
  font-size: 15px;
  color: #2c4059;
}

.club-row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 14px;
  background: rgba(255,255,255,0.5);
  border: 1px solid #bfd0ea;
  border-top: none;
}

.club-label {
  font-weight: 600;
  min-width: 92px;
}

.club-select {
  width: 420px;
  height: 32px;
  border: 1px solid #b8c5d9;
  background: #fff;
  padding: 0 10px;
  border-radius: 3px;
}

.content-shell {
  border: 1px solid #bfd0ea;
  border-top: none;
  background: rgba(255,255,255,0.3);
}

.tab-bar {
  display: flex;
  gap: 0;
  background: rgba(255,255,255,0.25);
}

.tab-btn {
  border: 1px solid #bfd0ea;
  border-bottom: none;
  background: #e8edf7;
  color: #2d405a;
  padding: 10px 18px;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
  text-transform: uppercase;
}

.tab-btn + .tab-btn {
  margin-left: 2px;
}

.tab-btn.active {
  background: #eef6ff;
}

.main-panels {
  display: grid;
  grid-template-columns: 380px 1fr;
  border-top: 1px solid #bfd0ea;
  min-height: 670px;
}

.list-panel {
  border-right: 1px solid #bfd0ea;
  background: rgba(255,255,255,0.18);
}

.list-header,
.list-row {
  display: grid;
  grid-template-columns: 1.7fr 0.5fr 0.7fr;
  align-items: center;
  min-height: 42px;
}

.list-header {
  background: #e9f0f9;
  border-bottom: 1px solid #bfd0ea;
  font-weight: 700;
  color: #2d405a;
  text-transform: uppercase;
  font-size: 12px;
}

.header-cell,
.package-text,
.holes-text,
.status-text {
  padding: 10px 12px;
  border-right: 1px solid #bfd0ea;
}

.list-row {
  background: #f7fafe;
  border-bottom: 1px solid #dfeaf7;
  cursor: pointer;
}

.list-row.selected {
  background: #f4d275;
  font-weight: 700;
}

.package-mark {
  color: #b15d00;
  margin-right: 6px;
  font-size: 12px;
}

.package-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.holes-text,
.status-text {
  text-align: center;
}

.detail-panel {
  background: rgba(255,255,255,0.15);
  padding: 14px 16px 10px;
}

.detail-topbar {
  display: flex;
  gap: 18px;
  margin-bottom: 10px;
}

.field-row {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 220px;
}

.field-row.big {
  width: 100%;
}

.field-row label {
  min-width: 110px;
  font-weight: 700;
  color: #2d405a;
}

.field-row input {
  flex: 1;
  height: 32px;
  border: 1px solid #b8c5d9;
  background: #ebeff5;
  padding: 0 10px;
  border-radius: 3px;
}

.field-right {
  margin-left: auto;
  width: 180px;
}

.detail-middle {
  display: grid;
  grid-template-columns: minmax(0, 1.7fr) 300px;
  gap: 20px;
  margin-top: 8px;
}

.left-form {
  background: rgba(255,255,255,0.2);
  border: 1px solid #d5e0f0;
  padding: 12px 12px 8px;
}

.form-block {
  border: 1px solid #d5e0f0;
  background: #f5f8fc;
  padding: 12px 10px 10px;
  margin-bottom: 12px;
}

.inline-row {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 12px;
}

.inline-row.small-gap {
  gap: 8px;
}

.compact-row {
  flex-wrap: wrap;
}

.label-col {
  min-width: 150px;
  font-weight: 700;
  color: #2d405a;
}

.radio-group,
.checkboxes,
.radio-inline {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  font-size: 13px;
}

.label-inline {
  font-weight: 700;
  margin-right: 8px;
}

.checkboxes label,
.radio-inline label {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
}

.note-row input {
  flex: 1;
  height: 32px;
  border: 1px solid #b8c5d9;
  background: #e9eef5;
  padding: 0 10px;
}

.meta-row {
  display: flex;
  gap: 16px;
  margin-top: 16px;
}

.meta-box {
  flex: 1;
  background: #e9edf4;
  border: 1px solid #c9d5e8;
  padding: 8px 10px;
  min-height: 70px;
}

.meta-box label {
  display: block;
  font-size: 12px;
  color: #566a86;
  margin-bottom: 6px;
  font-weight: 700;
}

.meta-value,
.meta-user {
  font-size: 12px;
  color: #2d405a;
}

.meta-user {
  margin-top: 6px;
}

.button-row {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 18px;
}

.btn {
  border: 1px solid #b9c7dc;
  background: #f5f7fb;
  color: #2d405a;
  padding: 7px 14px;
  font-size: 12px;
  cursor: pointer;
  border-radius: 3px;
}

.btn-primary {
  background: #dfeaf9;
  border-color: #aac0df;
}

.save-btn {
  margin-left: auto;
}

.right-panel {
  display: flex;
  align-items: flex-start;
  justify-content: center;
}

.membership-box {
  width: 100%;
  border: 1px solid #cedae8;
  background: #f8fafd;
  min-height: 220px;
}

.membership-header {
  background: #e8edf7;
  border-bottom: 1px solid #cedae8;
  padding: 8px 10px;
  font-size: 12px;
  font-weight: 700;
  color: #2d405a;
  text-transform: uppercase;
}

.membership-list {
  padding: 10px;
}

.membership-item {
  border: 1px solid #d3dce9;
  background: #f5f8fb;
  padding: 6px 8px;
  font-size: 12px;
  margin-bottom: 6px;
  color: #2d405a;
}

.membership-item.selected {
  background: #f8e7a3;
  border-color: #f0ce65;
  font-weight: 700;
}

.membership-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 0 10px 10px;
}

.check-inline {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
}

.small-btn {
  padding: 5px 10px;
}

.package-item-view {
  padding: 0 0 12px;
}

.package-item-shell {
  border: 1px solid #bfd0ea;
  background: rgba(255,255,255,0.15);
}

.package-item-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 12px;
  background: #eef5ff;
  border-bottom: 1px solid #bfd0ea;
  font-size: 12px;
  color: #2d405a;
}

.row-1 {
  font-weight: 700;
}

.header-code {
  display: inline-block;
  min-width: 90px;
  background: #e2e8f5;
  border: 1px solid #bfd0ea;
  padding: 5px 10px;
  text-align: center;
}

.row-2 {
  justify-content: space-between;
  background: #f8fafd;
}

.header-label {
  font-weight: 700;
  font-size: 16px;
}

.mini-btn {
  border: 1px solid #b8c5d9;
  background: #f5f7fb;
  color: #2d405a;
  padding: 4px 12px;
  font-size: 12px;
  cursor: pointer;
}

.item-layout {
  display: grid;
  grid-template-columns: 300px 1fr;
  min-height: 520px;
}

.period-panel {
  border-right: 1px solid #bfd0ea;
  background: rgba(255,255,255,0.15);
  padding: 14px 10px;
}

.period-box {
  border: 1px solid #bfd0ea;
  background: #f5f8fc;
}

.period-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
}

.period-cell {
  padding: 8px 10px;
  border-bottom: 1px solid #bfd0ea;
  font-size: 12px;
}

.period-cell.label {
  background: #e4edf8;
  border-right: 1px solid #bfd0ea;
  font-weight: 700;
}

.period-cell.value {
  background: #f9fbff;
}

.period-meta {
  margin-top: 12px;
  border: 1px solid #bfd0ea;
}

.meta-row-box {
  display: grid;
  grid-template-columns: 1fr 1fr;
  border-bottom: 1px solid #bfd0ea;
  font-size: 12px;
}

.meta-row-box:last-child {
  border-bottom: none;
}

.meta-label {
  background: #e4edf8;
  border-right: 1px solid #bfd0ea;
  padding: 8px 10px;
  font-weight: 700;
}

.meta-value {
  background: #f9fbff;
  padding: 8px 10px;
  text-align: right;
}

.price-panel {
  padding: 14px 12px 12px;
}

.price-panel-header {
  font-size: 18px;
  font-weight: 700;
  color: #2d405a;
  margin-bottom: 12px;
}

.price-table {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #bfd0ea;
  background: #fff;
  table-layout: fixed;
}

.price-table th,
.price-table td {
  border: 1px solid #bfd0ea;
  padding: 8px 10px;
  text-align: center;
  font-size: 12px;
  color: #2d405a;
}

.price-table th {
  background: #e9f0f9;
  font-weight: 700;
}

.price-table tbody tr:nth-child(odd) {
  background: #fafcff;
}

.price-table tbody tr {
  cursor: pointer;
  transition: background-color 0.2s;
}

/* Style saat baris dipilih */
.price-table tbody tr.is-selected {
  background-color: #e3f2fd; /* Warna latar belakang highlight */
  font-weight: bold;
}

.summary-grid {
  margin-top: 18px;
  border: 1px solid #bfd0ea;
  background: #fff;
}

.summary-row {
  display: grid;
  grid-template-columns: 1.6fr 1fr 1fr 1fr 1fr;
  border-bottom: 1px solid #bfd0ea;
}

.summary-row:last-child {
  border-bottom: none;
}

.summary-row.head {
  background: #e9f0f9;
  font-weight: 700;
  text-transform: uppercase;
}

.summary-row span {
  border-right: 1px solid #bfd0ea;
  padding: 8px 10px;
  font-size: 12px;
}

.summary-row span:last-child {
  border-right: none;
}

.summary-row.total {
  background: #f9fbff;
}

@media (max-width: 1100px) {
  .main-panels {
    grid-template-columns: 1fr;
  }

  .list-panel {
    border-right: none;
    border-bottom: 1px solid #bfd0ea;
  }

  .detail-middle {
    grid-template-columns: 1fr;
  }

  .item-layout {
    grid-template-columns: 1fr;
  }

  .period-panel {
    border-right: none;
    border-bottom: 1px solid #bfd0ea;
  }
}
</style>



// WEBPACK FOOTER //
// PackageRate.vue?8062470a